import { useTranslation } from "react-i18next"
import { Header, Text } from "../."
import { GoogleLogoIcon } from "../icons/GoogleLogoIcon"
import { StyledButton } from "./StyledButton"

interface SignInButtonProps {
	onClick: () => void
}

export const SignInButton = ({ onClick }: SignInButtonProps) => {
	const { t } = useTranslation()

	return (
		<StyledButton
			onClick={onClick}
			style="flex flex-row gap-[34px] w-full max-w-[300px] items-center justify-center rounded-lg border border-white py-[14px] px-[24px]"
		>
			<Header left={<GoogleLogoIcon />} center={<Text variant="normal-bold">{t("landing.login_button")}</Text>} />
		</StyledButton>
	)
}
